import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { AppComponent } from './app.component';

import { MAT_DATE_LOCALE } from '@angular/material/core';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatToolbarModule} from '@angular/material/toolbar';
import { MatIconModule} from '@angular/material/icon';
import { MatSidenavModule} from '@angular/material/sidenav';
import { MatListModule} from '@angular/material/list';
import { MatButtonModule} from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatInputModule } from '@angular/material/input';
import { MatExpansionModule } from '@angular/material/expansion'; 
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRippleModule } from '@angular/material/core';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatMomentDateModule, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';

import { AppRoutingModule } from './app-routing.module';
import { WhiskyCardComponent } from './components/whisky/whisky-card/whisky-card.component';
import { WhiskyListComponent } from './components/whisky/whisky-list/whisky-list.component';
import { WineListComponent } from './components/wine/wine-list/wine-list.component';

import { AdminComponent } from './components/admin/admin/admin.component';
import { WhiskyAdminComponent } from './components/admin/whisky-admin/whisky-admin.component';
import { WhiskyAddComponent } from './components/admin/whisky-add/whisky-add.component';
import { WhiskyEditComponent } from './components/admin/whisky-edit/whisky-edit.component';

import { NgxCsvParserModule } from 'ngx-csv-parser';
import { WhiskyDetailsComponent } from './components/whisky/whisky-details/whisky-details.component';
import { WhiskyBottleAdminComponent, WhiskyBottleAdminAddComponent } from './components/admin/whisky-bottle-admin/whisky-bottle-admin.component';
import { LoginFormComponent } from './auth/login-form/login-form.component';
import { LoginIconComponent } from './auth/login-icon/login-icon.component';



@NgModule({
  declarations: [
    AppComponent,
    WhiskyCardComponent,
    WhiskyListComponent,
    WineListComponent,
    AdminComponent,
    WhiskyAdminComponent,
    WhiskyAddComponent,
    WhiskyEditComponent,
    WhiskyDetailsComponent,
    WhiskyBottleAdminComponent,
    WhiskyBottleAdminAddComponent,
    LoginFormComponent,
    LoginIconComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    MatToolbarModule,
    MatSidenavModule,
    MatListModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    MatSlideToggleModule,
    MatInputModule,
    MatExpansionModule,
    NgxCsvParserModule,
    MatTabsModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    RouterModule,
    MatFormFieldModule,
    FormsModule,
    MatRippleModule,
    MatGridListModule,
    MatDialogModule,
    MatDatepickerModule,
    MatMomentDateModule,
    MatNativeDateModule,
    MatSelectModule,
    MatCheckboxModule,
    MatChipsModule,
    ReactiveFormsModule
  ],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'de-CH'},
    {provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: {useUtc: true}}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
